// Retrieve the django notifications from the store
// and pass them to the Notifications component
// use api service to fetch notifications
//   
import React, { useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import api from '../../services/api';
import Notification from './Notification';
import './notifications.scss';


const fetchNotifications = async () => {
  try{
    const res = await api.get('/api/admin/notifications/');
    if (res.status === 200) {
      return res.data;
    }else{
      return [];
    }
  }catch(err){
    return [];
  }
};

const Notifications = () => {
  const { data: fetchedNotifications, isLoading, error, refetch } = useQuery('notifications', fetchNotifications);
  const [notifications, setNotifications] = useState([]);
  // Initialize local notifications state with fetched data
  useEffect(() => {
    if (fetchedNotifications) {
      setNotifications(fetchedNotifications);
    }
  }, [fetchedNotifications]);

  // Schedule a pull every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      refetch();
    }, 5000);
    return () => clearInterval(interval);
  }, [refetch]);

   // Handler to dismiss a notification
  const handleDismiss = async (id) => {
    // try {
    //   const response = await fetch(`/api/notifications/${id}/dismiss`, {
    //     method: 'POST', // Use 'DELETE' if your API expects it
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //   });
    //   if (!response.ok) {
    //     throw new Error('Failed to dismiss notification');
    //   }
      // Remove the notification from local state to trigger UI update
      setNotifications((prev) => prev.filter((notification) => notification.id !== id));
      // Optionally, refetch to synchronize with backend
      // refetch();
    // } catch (err) {
    //   console.error(err);
    //   // Optionally, handle the error (e.g., display an error notification)
    // }
  };

  if (isLoading) return null; // Optionally, display a loader
  if (error) return <div className="notification error">Error: {error.message}</div>;

  if (!notifications || notifications.length === 0) {
    return null;
  }

  return (
    <div className="notifications">
      {notifications.map((notification) => (
        <Notification
          key={notification.id}
          notification={notification}
          onDismiss={handleDismiss} // Pass the dismiss handler to child
        />
      ))}
    </div>
  );
};

export default Notifications;